import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';

import { hideMessage, showMessage } from 'app/store/fuse/messageSlice';
import DeployService from 'app/admin/deploy/service/DeployService';
import { getUserData, logoutUser } from './store/userSlice';
import { checkLoginState } from './store/loginSlice';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const isOnHashRoute = (path) => {
  const route = String(path || '').startsWith('/') ? String(path || '') : `/${String(path || '')}`;
  return (window.location.hash || '').startsWith(`#${route}`);
};

const goToHashRoute = (path) => {
  const route = String(path || '').startsWith('/') ? String(path || '') : `/${String(path || '')}`;
  const targetHash = `#${route}`;

  if ((window.location.hash || '') === targetHash) return;

  window.location.hash = route;
};

class Auth extends Component {
  state = {
    waitAuthCheck: true
  };

  componentDidMount() {
    return Promise.all([this.authCheck()]).then(() => {
      this.setState({ waitAuthCheck: false });
    });
  }

  authCheck = () => {
    return new Promise(resolve => {
      const WAIT_BEFORE_GET_STATE_MS = 600;

      wait(WAIT_BEFORE_GET_STATE_MS)
        .then(() => DeployService.getState())
        .then(data => {
          const deployState = data?.state;

          if (deployState !== 'OK') {
            try { sessionStorage.setItem('deployState', String(deployState || '')); } catch (e) {}

            if (!isOnHashRoute('/registration')) {
              goToHashRoute('/registration');
            }

            resolve();
            return null;
          }

          return Promise.resolve(this.props.checkLoginState())
            .then(() => resolve())
            .catch(() => resolve());
        })
        .catch(() => {
          if (!isOnHashRoute('/registration')) {
            goToHashRoute('/registration');
          }
          resolve();
        });
    });
  };

  render() {
    return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: logoutUser,
      getUserData,
      checkLoginState,
      showMessage,
      hideMessage
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Auth);
